import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-get-started',
    templateUrl: './get-started.component.html',
    styleUrls: ['./get-started.component.css'],
    standalone: false
})
export class GetStartedComponent {
  @Output() goNext: EventEmitter<any> = new EventEmitter<any>();

  isAcceptTermsOfUse = null;
  privacyPolicyTermsOfUse = "https://www.careloninsights.com/privacy";

  begin(): void {
    this.goNext.emit();
  }
}
